import React from "react";
import { Navigate, Route, Routes } from "react-router";
import { authRoutes, publicRoutes } from "./router.link";
import Feature from "../feature";
import AuthFeature from "../authFeature";
import Login from "../auth/login/login";

const ALLRoutes: React.FC = () => {
  const loginValue = localStorage.getItem("login");

  // console.log("🔥 ALLRoutes rendered"); // Log every render

  return (
    <Routes>
      {loginValue === "true" ? (
        <Route element={<Feature />}>
          {publicRoutes.map((route, idx) => (
            <Route path={route.path} element={route.element} key={idx} />
          ))}
        </Route>
      ) : (
        <>
          <Route path="/login" element={<Login />} />
          {publicRoutes.map((route, idx) => (
            <Route
              key={idx}
              path={route.path}
              element={<Navigate to="/login" />}
            />
          ))}
        </>
      )}

      <Route element={<AuthFeature />}>
        {authRoutes.map((route, idx) => (
          <Route path={route.path} element={route.element} key={idx} />
        ))}
      </Route>
    </Routes>
  );
};

export default ALLRoutes;

// import React from "react";
// import { Navigate, Route, Routes } from "react-router";
// import { authRoutes, publicRoutes } from "./router.link";
// import Feature from "../feature";
// import AuthFeature from "../authFeature";
// import Login from "../auth/login/login";

// const ALLRoutes: React.FC = () => {
//   const loginValue = localStorage.getItem("login");
//   // console.log("login value", typeof loginValue);
//   return (
//     <>
//       {/* <Routes>
//         {loginValue === "true" ? (
//           <Route element={<Feature />}>
//             {publicRoutes.map((route, idx) => (
//               <Route path={route.path} element={route.element} key={idx} />
//             ))}
//           </Route>
//         ) : (
//           <>
//             <Route path="/login" element={<Login />} />
//             {publicRoutes.map((route, idx) => (
//               <Route
//                 key={idx}
//                 path={route.path}
//                 element={<Navigate to="/login" />}
//               />
//             ))}
//           </>
//         )}

//         <Route element={<AuthFeature />}>
//           {authRoutes.map((route, idx) => (
//             <Route path={route.path} element={route.element} key={idx} />
//           ))}
//         </Route>
//       </Routes> */}

//       <Routes>
//         {loginValue === "true" ? (
//           <Route element={<Feature />}>
//             {publicRoutes.map((route, idx) => (
//               <Route key={idx} path={route.path} element={route.element} />
//             ))}
//           </Route>
//         ) : (
//           <Route element={<AuthFeature />}>
//             <Route path="/login" element={<Login />} />
//             {/* Catch all: redirect anything else to /login */}
//             <Route path="*" element={<Navigate to="/login" replace />} />
//           </Route>
//         )}
//       </Routes>

//     </>
//   );
// };

// export default ALLRoutes;
